import http from "./httpservices";
import GetCookieByName from "../hooks/GetCookie";

function getAuthToken() {
  try {
    const raw = GetCookieByName("auth");
    if (typeof raw !== "string") return undefined;
    return JSON.parse(raw)["token"];
  } catch {
    return undefined;
  }
}

export async function getContactNumber(params) {
    const { data } = await http.post('plugin/viewInfluencerDetails', params, {
        headers: { "x-auth-token": getAuthToken() },
    });
    return data;
}

export async function requestContactNumber(params) {
    const { data } = await http.post('plugin/requestInfluencerDetails', params, {
        headers: { "x-auth-token": getAuthToken() },
    });
    return data;
}

// Bulk request (Plans "Request Contact") — one call for the whole list.
export async function requestContactNumbers(handles) {
    const { data } = await http.post('plugin/requestInfluencerDetails/bulk', { handles }, {
        headers: { "x-auth-token": getAuthToken() },
    });
    return data;
}

export async function viewRequestedInfluencersNumbers() {
    const { data } = await http.get('plugin/viewRequestedInfluencers', {
        headers: { "x-auth-token": getAuthToken() },
    });
    return data;
}

export default {
    getContactNumber,
    requestContactNumber,
    requestContactNumbers,
    viewRequestedInfluencersNumbers
};